import React from "react";
import image_link from "../assets/images/logo_ma_prime_renov.jpg";

const AidesView = (props) => {
    return(
        <>
            <div className="title-container services-title">
                <div className="title">
                    <div className="title-fade"></div>
                    <div className="title-outline"></div>
                    <h1>Aides gouvernementales</h1>
                </div>
                <div className="title-gradient"></div>
            </div>
            <div className="content">
                <img className="ma-prime-renov" alt="Logo de Ma Prime Rénov'" src={image_link}/>
                <p>
                    <strong><b>Aides à la rénovation énergétique : profitez-en !</b></strong>
                    <br />
                    <br />
                    Saviez-vous que des <strong>aides financières de l’État</strong> existent pour vos travaux de rénovation énergétique ?
                    <br />
                    Que ce soit pour le remplacement de votre chauffe-eau, l'installation d'une chaudière plus performante ou d'autres travaux visant à améliorer l'efficacité énergétique de votre logement, <strong>plusieurs dispositifs peuvent alléger considérablement votre facture</strong>.
                    <br />
                    <br />
                    MaPrimeRénov’, CEE (Certificats d'Économies d'Énergie), TVA réduite...
                    <br />
                    Ces aides sont accessibles sous certaines conditions, et peuvent représenter plusieurs centaines, voire milliers d’euros.
                    <br />
                    <br />
                    <strong><b>Bonne nouvelle : On s’occupe de tout !</b></strong>
                    <br />
                    De la constitution du dossier à la transmission des justificatifs, nous vous accompagnons dans toutes les démarches administratives pour que vous puissiez bénéficier des aides auxquelles vous avez droit, sans tracas.
                    <br />
                    <br />
                    <strong><b>Faites des économies</b></strong> tout en améliorant votre confort. Contactez-nous pour en savoir plus !
                </p>
            </div>
        </>
    );
};

export default AidesView;